import React from 'react';
import HomeIcon from '../../assets/allIcons/HomeIcon';
import PrevIcon from '../../assets/allIcons/PrevIcon';
import useWindowDimensions from '../Lk/useWindowDimensions';
import { FooterBlock, Botton } from './Footer.style';

const Footer = ({
    nextBtnText,
    nextBtnIcon,
    leftMargin,
    goToPreviousPath,
    goToHome,
    goToNext,
    isDisabledNextBtn
}) => {

    return (
        <FooterBlock leftMargin={leftMargin}>
            <Botton onClick={goToPreviousPath}><PrevIcon />Назад</Botton>
            {useWindowDimensions().width > 600 && <Botton onClick={goToHome}><HomeIcon /> На главную</Botton>}
            {useWindowDimensions().width > 600 && <Botton></Botton>}
            {/* <Botton onClick={goToNext} disabled={isDisabledNextBtn}>{nextBtnText}{nextBtnIcon}</Botton> */}
        </FooterBlock>
    )
}

export default Footer;
